import { gql, GraphQLClient } from 'graphql-request'

interface GlobalResponse {
  factories: {
    totalVolumeUSD: string
    totalValueLockedUSD: string
  }[]
}
export const GLOBAL_DATA = () => {
  const queryString = ` query pancakeFactories {
      factories(first: 1) {
        totalVolumeUSD
        totalValueLockedUSD
      }
    }`
  return gql`
    ${queryString}
  `
}

export const fetchProtocolData = async (dataClient: GraphQLClient) => {
  const data = await dataClient.request<GlobalResponse>(GLOBAL_DATA())

  const parsed = data?.factories?.[0]
  const { totalVolumeUSD, totalValueLockedUSD } = parsed

  return {
    totalVolumeUSD,
    totalValueLockedUSD,
  }
}
